<template>
	<div class="row m-0" >
        <div class="col-md-12" style="background:var(--blue)"><p class="header-bar">CASH REPORT</p></div>
        <div class="col-md-12" v-for="(date, index) in dates" v-bind:key="index">
          <!-- <h4 class="title-bar">CASH REPORT as on {{date}}</h4> -->
          <TableView :col="columns" :addFilter="{'report_date': date}" :getData="getData"/>  
        </div>
	</div>
</template>
<script>
import common from '@/assets/js/common.js';
import moment from 'moment';
export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  mixins: [common],
  props: ['report_date', 'row', 'base_currency'],
  data(){
  	return {
      showTableView: false,
      res: {},
      dates: {},
      columns: (() => {
        const cols = [
          { title: 'Security Type', field: 'type_of_security'},
          { title: 'Type', field: 'type'},
          { title: 'Trade Date', field: 'trade_date'},
          { title: 'Settlement Date', field: 'settlement_date'},
          { title: 'Cost Price', field: 'cost_price' , tdComp: 'Number'},
          { title: 'Currency', field: 'lcy', tdClass:"p1rem"},
          { title: 'Narrative', field: 'narrative'},
          { title: 'Total Charges', field: 'total_charges', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Realized PNL', field: 'realized_pnl', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Cash Balance', 'sub_title': '(trade date)', thComp: 'two-line-title', field: 'td_cash', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Cash Balance', 'sub_title': '(Settlement date)', thComp: 'two-line-title', field: 'sd_cash' , tdComp: 'Number', 'floatLength': 2},
          { title: 'FX Rate', field: 'fx_rate', tdComp: 'Number', 'floatLength': 5},
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('report', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  created() {
    
  },
  mounted() {
    let date = typeof this.report_date == 'string' ? this.report_date.split(',') : this.report_date;
    var start = moment(date[0], 'DD-MM-YYYY');
    var end = date[1] ? moment(date[1], 'DD-MM-YYYY') : moment(date[0], 'DD-MM-YYYY');
    /* let loop = start;
    this.dates = {0: start.format('DD-MM-YYYY')};
    let i = 1;
    while (end.diff(loop, 'days') >= 1) {
        loop = loop.add(1, 'days');
        this.dates[i] = loop.format('DD-MM-YYYY');
        i++;
    } */
    this.dates = {0: end.format('DD-MM-YYYY')};
  },
  methods: {
    async getData(query, filter) {
        // var { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
        let uri = 'cash_activity_report?with_settlement=1&account_number='+this.row.account_number+'&report_date='+filter['report_date']+'&base_cur='+this.base_currency;
        return await this.call_axios(uri, 'get', {}, false);
    },
  }
}
</script>
<style>
.title-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  padding: 10px 0 0 0;
}
</style>